export const Path = {
	online: '/online/',
	history: '/desktop_app/history.php',
};
